var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlassCard',{staticClass:"col-md-2 mb-3 py-3"},[_c('div',{staticClass:"col-sm-12 col-md-12 h-100 m-0 p-0"},[_c(_vm.activeComponent,{tag:"component",on:{"component":function($event){_vm.activeComponent = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }